export const WorkOrdersComponentsPaths = {
  WorkOrders: 'work-orders',
}

export const WorkOrdersComponentsRoutes = {
  WorkOrders: `/fleet-maintenance/${WorkOrdersComponentsPaths.WorkOrders}`,
}
